import { z } from 'zod'

/** Where a confirmation PixelSign asked for on its own page stands. */
export const MCP_CONFIRMATION_STATUSES = ['pending', 'confirmed', 'declined', 'expired'] as const

export const mcpConfirmationStatusSchema = z.enum(MCP_CONFIRMATION_STATUSES)

export type McpConfirmationStatus = z.infer<typeof mcpConfirmationStatusSchema>

export const PRISMA_MCP_CONFIRMATION_STATUSES = ['PENDING', 'CONFIRMED', 'DECLINED', 'EXPIRED'] as const

export type PrismaMcpConfirmationStatus = (typeof PRISMA_MCP_CONFIRMATION_STATUSES)[number]

export const MCP_CONFIRMATION_STATUS_FROM_PRISMA = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  DECLINED: 'declined',
  EXPIRED: 'expired',
} as const satisfies Record<PrismaMcpConfirmationStatus, McpConfirmationStatus>

export const MCP_CONFIRMATION_STATUS_TO_PRISMA = {
  pending: 'PENDING',
  confirmed: 'CONFIRMED',
  declined: 'DECLINED',
  expired: 'EXPIRED',
} as const satisfies Record<McpConfirmationStatus, PrismaMcpConfirmationStatus>

/** The button on the confirm page. `confirm` is recorded as status `confirmed`. */
export const MCP_CONFIRMATION_DECISIONS = ['confirm', 'decline'] as const

export const mcpConfirmationDecisionSchema = z.enum(MCP_CONFIRMATION_DECISIONS)

export type McpConfirmationDecision = z.infer<typeof mcpConfirmationDecisionSchema>
